var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPinGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C3.0975 0.5 0.75 2.8475 0.75 5.75C0.75 7.055 1.125 8.2775 1.8075 9.38C2.52 10.535 3.4575 11.525 4.1775 12.68C4.53 13.2425 4.785 13.7675 5.055 14.375C5.25 14.7875 5.4075 15.5 6 15.5C6.5925 15.5 6.75 14.7875 6.9375 14.375C7.215 13.7675 7.4625 13.2425 7.815 12.68C8.535 11.5325 9.4725 10.5425 10.185 9.38C10.875 8.2775 11.25 7.055 11.25 5.75C11.25 2.8475 8.9025 0.5 6 0.5ZM6 7.8125C4.965 7.8125 4.125 6.9725 4.125 5.9375C4.125 4.9025 4.965 4.0625 6 4.0625C7.035 4.0625 7.875 4.9025 7.875 5.9375C7.875 6.9725 7.035 7.8125 6 7.8125Z",
    fill: "#003030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinGreen);
export default __webpack_public_path__ + "static/media/location-pin-green.43f0a587f430d2d789c2c275affe9a4b.svg";
export { ForwardRef as ReactComponent };